export default "__VITE_ASSET__lXACeU1H__"